import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annex',
  templateUrl: './annex.component.html',
  styleUrls: ['./annex.component.scss']
})
export class AnnexComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
